import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Container,
  Paper,
  TextField,
  ThemeProvider,
  createTheme,
  CircularProgress,
  Divider,
  Alert,
  Tooltip,
  Zoom,
  Fade,
  Checkbox,
  FormControlLabel,
  Stack
} from '@mui/material';


import {
  Check as CheckIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import FactCheckerApi from '../apis/fact_checker';

import { Stepper, Step, StepLabel, StepContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import GetAppIcon from '@mui/icons-material/GetApp';
import ExtensionIcon from '@mui/icons-material/Extension';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TurnstileWidget from '../Components/TurnstileWidget';
import { useCallback, useRef } from 'react';
// CredibilityMark component

const CredibilityMark = ({ score, title, imageSrc, imageAlt }) => {
  // Determine color based on score
  let color = '#f44336'; // Red (low credibility)
  let label = 'Low Credibility';

  if (score >= 70) {
    color = '#4caf50'; // Green (high credibility)
    label = 'High Credibility';
  } else if (score >= 40) {
    color = '#ff9800'; // Yellow/Orange (medium credibility)
    label = 'Medium Credibility';
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      p: 2
    }}>
      {/* Image logo */}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={imageAlt || title}
          style={{ marginTop: 8, maxWidth: '100px', height: '55px' }}
        />
      )}
      {title && (
        <Typography
          variant="h6"
          component="div"
          sx={{
            mb: 2,
            fontWeight: 'medium',
            textAlign: 'center',
            fontSize: '1rem'
          }}
        >
          {title}
        </Typography>
      )}
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={score}
          size={65}
          thickness={5}
          sx={{ color: color }}
        />

        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" component="div" color="text.secondary" sx={{ fontSize: '1rem' }}>
            {score}%
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="body1"
        sx={{
          mt: 1,
          fontWeight: 'bold',
          color: color
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default CredibilityMark;